// extracted by mini-css-extract-plugin
module.exports = {"selectedCount":"userGroupsTargets_selectedCount__2gPkP sharedStyles_selected-count__313M3"};